import styled from 'styled-components';
import { LinearProgress } from '@mui/material';

import LinkButton from '../../../../../../components/Button/LinkButton';
import colors from '../../../../../../styles/colors';

/*
  Never shrinks: the table above is what absorbs the page's spare height, so an upload row has to
  keep its own or it collapses the moment the grid is full.
*/
const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 8px;
  margin-top: 12px;
`;

const UploadRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 16px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 8px;
  background-color: ${colors.shades.secondary10};
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

const StatusText = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => (props.$hasFailed ? colors.base.danger : colors.shades.secondary3)};
`;

const FileName = styled.div`
  font-size: 12px;
  color: ${colors.shades.gamma10};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 2;
`;

const StyledLinearProgress = styled(LinearProgress)`
  flex: 1;
  height: 6px;
  border-radius: 3px;
`;

const ProgressValue = styled.div`
  font-size: 12px;
  color: ${colors.shades.gamma10};
  /* Fixed so the bar does not jump a few pixels every time the percentage gains a digit. */
  width: 34px;
  text-align: right;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const TextButton = styled(LinkButton)`
  padding: 0;
  min-width: auto;
  font-size: 13px;
`;

export {
  Container,
  UploadRow,
  Details,
  StatusText,
  FileName,
  ProgressContainer,
  StyledLinearProgress,
  ProgressValue,
  Actions,
  TextButton,
};
